module.exports = __webpack_public_path__ + "static/img/li_top3.0152398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/li_top3.png
// module id = Z0c+
// module chunks = 1